<div class="mainBody">
    <div class="container-fluid loginContainer">
        <div class="col-md-12 mt-1">
            <!-- <img src="../../../assets/images/CanString AI logo.svg" class="CanString-AI-logo"> -->
                <img style="width:50px;" src="../../../../assets/images/5_image.jpg" class="CanString-AI-logo align-items-center">
                         <span style="
    padding: 10px;
    font-size: 1.3rem;
">AI Analytics</span>
        </div>
        <div class="row mt-4">
            <div class="col-md-12 d-flex">
                <div class="col-md-6">
                    <img src="../../../assets/images/cs-analytics-ban.svg" class="backImageClass">
                   
                </div> 
                <div class="col-md-6">
                  <div class="d-flex flex-column justify-content-center align-items-center full-height-percentage">
                    
                    <span id="logo">
                        <!-- <img src="../../../assets/images/CanString AI logo.svg" class="CanString-AI-logo align-items-center"> -->
                         <img style="width:50px;" src="../../../../assets/images/5_image.jpg" class="CanString-AI-logo align-items-center">
                         <span style="
    padding: 10px;
    font-size: 1.3rem;
">AI Analytics</span>
                      <span class="version-div">
                        <!-- <b class="version-2">V 3.0</b> -->
                      </span>
                </span>
                @if(BASE_LOGIN =="call"){
                     @switch(userFormIndication){
                        @case ('login') {
                            <app-login (formChange)="navigateForm($event)"></app-login>
                        }
                        @case ('signup'){
                            <app-sign-up (formChange)="navigateForm($event)"></app-sign-up>
                        }
                        @case('verify'){
                            <app-verify (formChange)="navigateForm($event)"></app-verify>
                        }
                        @case('forgotpass'){
                            <app-forgot-password (formChange)="navigateForm($event)"></app-forgot-password>
                        }
                    }
                }
                    
                         
                      
                    </div>
                </div>  
            </div>
        </div>
       
    </div>
</div>